// open mobile dropdown
document.querySelectorAll(".footerTitle.dropdown").forEach(function (element) {
    element.addEventListener("click", function () {
        let dropdown = this.parentElement.querySelector(".footerDropdown");
        if (this.classList.contains("active")) {
            dropdown.removeAttribute("style");
        } else {
            dropdown.style.height = `${dropdown.scrollHeight}px`;
        }
        this.classList.toggle("active");
    });
});